import { Button, ModalBody, ModalFooter } from '@chakra-ui/react';
import { Tab, Tabs } from '@gamma/ui/tabs';
import React, { useCallback, useMemo } from 'react';
import { i18n } from '@investigator/shared/localization';
import { EntityAnalysisModalTab } from '@investigator/shared/constants';
import { useEntitiesContext } from '../../../context';
import { useEntityAnalysisModalTabs } from '../../../hooks';
import { EntityAnalysisModalHeader } from '../EntityAnalysisModalHeader';

export const EntityAnalysisMainView: React.FC = () => {
  const {
    analysisModal: { onClose, activeTab, setActiveTab },
    selectedEntity,
  } = useEntitiesContext();

  const { tabs } = useEntityAnalysisModalTabs();

  const activeTabIndex = useMemo(
    () =>
      tabs.findIndex(
        (tab) =>
          tab.tab === (activeTab ?? EntityAnalysisModalTab.EntityOverview),
      ),
    [activeTab, tabs],
  );

  const handleTabChange = useCallback(
    (index: number) => {
      if (!setActiveTab) return;
      setActiveTab(tabs[index]?.tab ?? EntityAnalysisModalTab.EntityOverview);
    },
    [setActiveTab, tabs],
  );

  return (
    <>
      <EntityAnalysisModalHeader
        entityName={selectedEntity?.entityName}
        onClose={onClose}
      />
      <ModalBody
        overflowY="auto"
        flex="1"
        display="flex"
        flexDirection="column"
      >
        <Tabs variant="line" index={activeTabIndex} onChange={handleTabChange}>
          {tabs.map(({ tab, title, content: Content }) => (
            <Tab key={tab} title={title}>
              <Content />
            </Tab>
          ))}
        </Tabs>
      </ModalBody>
      <ModalFooter borderTop="1px solid" borderColor="border.layer.1">
        <Button variant="solid" colorScheme="gray" onClick={onClose}>
          {i18n.buttons.close}
        </Button>
      </ModalFooter>
    </>
  );
};
